import React from 'react'

const NoProductFound = () => {
  return (
    <div className='border p-2 text-center f14 text-uppercase fw-bold text-muted'>No Product FOUND </div>
  )
}

export default NoProductFound